import { getApi } from "./api_instance";

export const getProjectDetails = async (projectId, logout) => {
  try {
    const {data} = await getApi({
      apiUrl: `/admin/projects/api/${projectId}`,
      sendToken: true,
      logout,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
